export const hospitalOrderAction = (data) => { 
    return {
       type: data.type,
       data: data.data
    }
 }